import { Card, CardContent } from '@design-system/Card';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { TRISYNBIOTIC_DETAIL_PATH } from '@/constants/paths';
import { useATSData } from './useATSData';
import { ATS_PILL } from '@/constants/images';

export const TriSynbioticTaskCard = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useATSData();

  if (isLoading || !data) {
    return null;
  }

  const handleNavigate = () => {
    navigate(TRISYNBIOTIC_DETAIL_PATH);
  };

  return (
    <Card
      data-testid="home-triSynbioticTask"
      className="relative bg-background-blur-medium before:absolute before:shadow-glass-inner cursor-pointer"
      onClick={handleNavigate}
    >
      <CardContent className="flex items-center gap-4 p-4">
        <div className="shrink-0 w-[70px] h-[70px]">
          <img
            src={ATS_PILL}
            alt="Advanced TriSynbiotic™"
            className="w-full h-full object-contain mix-blend-multiply"
          />
        </div>

        <div className="flex flex-col gap-1 flex-1 min-w-0">
          <span className="typography-h3 text-secondary leading-snug">
            Start {data.title}
          </span>
          <span className="typography-body text-secondary text-sm">
            Start your 30-day gut prep with Viome {data.title}.
          </span>
          <span className="flex items-center text-success text-sm font-light mt-1">
            View details
            <ChevronRight className="h-5 w-5 ml-0.5" />
          </span>
        </div>
      </CardContent>
    </Card>
  );
};
